module.exports = __webpack_public_path__ + "img/astral_12.661d0d59.svg";